<div class="flex flex-col items-center h-full px-6 md:px-12 lg:px-27">
    <div id="calendarSection" class="flex flex-col items-start gap-6 lg:gap-10
             text-text-primary bg-background-primary shadow-md p-8 rounded-2xl">
        <div>
            <h2 class="h3-text lg:h2-text mb-2" i18n>Upcoming horse competitions</h2>
            <p class="body-m-text lg:body-l-text text-text-muted" i18n>Stay updated with the latest competitions around the world</p>
        </div>
        <table class="w-full table-fixed">
            <tr class="border-border-light border-b-2" *ngFor="let event of events">
                <td class="pr-4 py-4 lg:py-8 body-s-text-bold lg:h4-text max-w-72">{{event.startDate | date: 'MMMM d, y'}} - {{event.endDate | date: 'MMMM d, y'}}</td>
                <td class="text-accent-blue pr-4 py-4 lg:py-8 body-s-text-bold lg:h4-text">{{event.locationName}}</td>
                <td class="pr-4 py-4 lg:py-8 body-s-text lg:h4-text">{{event.eventRating}}</td>
                <td class="pr-4 py-4 lg:py-8 body-s-text lg:h4-text">
                    <span [ngSwitch]="event.eventType">
                        <span *ngSwitchCase="EventType.Showjumping" i18n="@@show-jumping-competition-type">Show jumping</span>
                        <span *ngSwitchCase="EventType.Dressage" i18n="@@dressage-competition-type">Dressage</span>
                        <span *ngSwitchCase="EventType.Eventing" i18n="@@eventing-competition-type">Eventing</span>
                        <span *ngSwitchCase="EventType.Endurance" i18n="@@endurance-competition-type">Endurance</span>
                        <span *ngSwitchCase="EventType.Polo" i18n="@@polo-competition-type">Polo</span>
                        <span *ngSwitchCase="EventType.Racing" i18n="@@racing-competition-type">Racing</span>
                    </span>
                </td>
            </tr>    
        </table>
        <button *ngIf="!endOfList" (click)="loadMoreEvents()"
            class="secondary-button"
            type="button" i18n>Load more</button>
    </div>
</div>